import { mainAPI } from "../api";
import {
    AuthResponse,
    OTPCredentials,
    OtpResponse,
    PhoneCredentials,
    RefreshToken,
    UsernamePasswordCredentials,
} from '../types/auth';
import { User } from "../types/users";

export function authWithUsernamePassword(
  credentials: UsernamePasswordCredentials
) {
  return mainAPI.post<AuthResponse>(`users/token/`, credentials).then(
    (res) => {
      const { access, refresh, role } = res.data;
      return Promise.resolve({
        access,
        refresh,
        role,
      });
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

export function refreshJWT(
  refresh: RefreshToken
) {
  return mainAPI.post<AuthResponse>(`users/token/refresh/`, refresh).then(
    (res) => {
      const { access, refresh, role } = res.data;
      return Promise.resolve({
        access,
        refresh,
        role,
      });
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

export function sendOTPOnEmail(credentials: PhoneCredentials) {
  return mainAPI
    .post<OtpResponse>("users/otp/create_otp/", credentials)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function verifyOTP(credentials: OTPCredentials) {
  return mainAPI.post<AuthResponse>("users/otp/verify_otp/", credentials).then(
    (res) => {
      const { access, refresh, role } = res.data;
      return Promise.resolve({
        access,
        refresh,
        role,
      });
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

export function retrieveOwnProfile(): Promise<User> {
  return mainAPI.get<User>(`users/own/profile/`).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}
